import type { FaireProductEntity } from "../../entity_types/product";

export const p_ep3mg42k6c: FaireProductEntity = {
  token: "p_ep3mg42k6c",
  type: "product",
  name: "Daily Moisturizing Sunscreen - SPF 35",
  brandToken: "b_ecjcctkpm8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/99d493a027e9d41114b2a9da05422d911ecb913a476b9df3a95818d70365bbb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1c24d0851a684f3be2d501da9bd8358b82299bd5e9d9f57e490998d68273851.webp",
    "https://cdn.faire.com/fastly/95193190ca4a7378d6c2a05470d5c288830ecf5bbdc8d1e30655c6f4f5aac48e.png",
    "https://cdn.faire.com/fastly/4b8cee248cd650f63040a1ba8e1a2db9783e0c7b0afd796ce139f281359a9a0a.png",
    "https://cdn.faire.com/fastly/af8ff96f9bca38886643e84352f6193f90260e1e73142211dda78a8b81e4eecb.webp",
    "https://cdn.faire.com/fastly/ab39d991432bbc2b64cef52a8fecc52f451672294d82a294897801cf5acad251.webp",
  ],
  priceDollars: 20.09,
  description:
    "A lightweight, non-tinted mineral SPF 35 with non-nano zinc oxide, tallow, niacinamide, and vitamin E. Reef-safe, fragrance-free, and leaves a smooth, natural finish — never chalky or greasy.",
  tags: [],
  msrpDollars: 40.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:32.354Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
